<template>
  <div>
    <el-drawer :visible.sync="changVisible" :title="title" size="300px" :before-close="$onClose" destroy-on-close>
      <el-checkbox-group v-model="checkList">
        <div>
          <el-checkbox label="学号" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="中文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="英文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="专业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="捐助时间"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="与学校关系"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="入校时间"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="捐助内容"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="票据"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="证书"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="捐助金额"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="捐助类型"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友类别"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="是否本硕连读"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="备注"></el-checkbox>
        </div>
      </el-checkbox-group>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      changVisible: false,
      title: '勾选表格显示字段',
      checkList: []
    }
  },
  methods: {
    $onClose(done) {
      this.$emit('toBackCheckList', this.checkList)
      done()
    },
    //页面初始化时加载的事件
    show(list) {
      this.checkList = list
      this.changVisible = true
    },
    // 还原
    onBack() {
      this.changVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
div {
  margin-left: 30px;
}
.this_table {
  width: 50%;
  margin: 0 auto;
}
.btn_back {
  float: right;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/journalsTableLabelDrawer.vue